import { CustomLink } from '../../../../components/CustomLink';
import UImage from '../../../../components/UImage';
import { chevron_right_white_9x14 } from '../../../../utils/common/variables';
import { useRecipeByIdQuery } from '../../../../utils/hook/react-query/recipe/useRecipeByIdQuery';
import useReferencingRecipeInfinityQuery from '../../../../utils/hook/react-query/recipe/useReferencingRecipeInfinityQuery';

import { useDiaryShortsContext } from './_DiaryShortsRoot';

const _DiaryShortsReferencedRecipe = () => {
  const { diary } = useDiaryShortsContext();
  const { data: recipe } = useRecipeByIdQuery(diary.recipeId, {
    enabled: !!diary.recipeId,
  });
  const { totalDiaryCount } = useReferencingRecipeInfinityQuery({
    recipeId: diary.recipeId ?? undefined,
  });

  if (!recipe || !totalDiaryCount)
    return (
      <p className="grow font-semibold text-gray-500">참고한 레시피가 없어요</p>
    );

  return (
    <CustomLink href={`/recipes/${recipe.id}`} className="grow">
      <div className="flex space-x-8px">
        {!!recipe.thumbnail && (
          <UImage
            src={recipe.thumbnail}
            width={40}
            height={40}
            className="h-40px w-40px shrink-0 rounded-10px"
          />
        )}
        <div className="space-y-8px">
          <div className="flex space-x-8px">
            <h5 className="text-16px font-semibold text-white line-clamp-1">
              {recipe.name}
            </h5>
            <img src={chevron_right_white_9x14} className="h-14px w-7px" />
          </div>
          <h6 className="text-14px font-medium text-gray-300">
            <span className="font-bold">{totalDiaryCount}</span>명이 참고한
            레시피
          </h6>
        </div>
      </div>
    </CustomLink>
  );
};

export default _DiaryShortsReferencedRecipe;
